export const checkHourValue = (myEventDate) => {
  const eventHour = myEventDate?.slice(-5)
  if (eventHour === "00:00") {
    return true
  }
  return false
}
